<template>
    <v-app-bar
      app
      clipped-right
      :color="getAppBarColor"
    >
      <v-app-bar-nav-icon color="white" @click="drawer = !drawer" />
      <span v-show="!drawer" class="title ml-3 mr-5 white--text">
        flyVendas
      </span>

      <v-spacer />

      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-icon
            v-on="on"
            class="mr-1"
            color="white"
            size="40"
          >
            mdi-account-circle
          </v-icon>
        </template>

        <v-card tile>
          <v-row class="pa-3" align="center" justify="center">
            <v-col cols="12" sm="12">
              <div class="text-center">
                <v-avatar
                  :color="getAppBarColor"
                  size="50"
                >
                  <span
                    class="white--text"
                    style="font-size: 14pt"
                  >
                    {{ getUser.nome.charAt(0) }}
                  </span>
                </v-avatar>
              </div>
              <div class="text-center mt-2">
                <h4 class="grey--text text--darken-2">{{ getUser.nome }}</h4>
                <h5 class="grey--text">{{ getUser.apelido }}</h5>
                <h5 class="grey--text">{{ getUser.email }}</h5>
                <h5 class="grey--text">{{ getUser.telefone }}</h5>
                <h5 class="grey--text">{{ getUser.papel }}</h5>
                <v-divider class="mt-1"></v-divider>

                <div class="mt-3">
                  <router-link class="link" :to="'/Profile'">Minha conta</router-link>
                </div>
                <div class="mt-3">
                  <a class="link" @click="logout()">Sair</a>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-menu>
    </v-app-bar>
</template>

<script>
import Auth from '@/services/auth'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'CoreAppBar',

    data() {
      return {

      }
    },

    computed: {
      ...mapGetters('app', ['getDrawer','getAppBarColor']),
      ...mapGetters('auth', ['getUser']),

      drawer: {
        get()  { return this.getDrawer },
        set(v) { this.setDrawer(v) }
      }
    },

    methods: {
      ...mapActions('app', ['setDrawer']),

      logout () {
      this.$swal.confirm('Deseja sair do sistema?').then(async () => {
        try {
          await new Auth().signOut()
          location.reload()
        } catch (error) {
          console.error(error)
          this.$toast.error(error)
        }
      })
    }
    }
}
</script>

<style lang="scss" scoped>
  .link {
    text-decoration: none;
    color: #4e4e4e;
  }

  .link:hover {
    color: #910000;
  }
</style>
